const relations = [
{value:'Son,Mother', name:'Son -> Mother'},
{value:'Mother,Son', name:'Mother -> Son'},
{value:'Father,Son', name:'Father -> Son'},
{value:'Son,Father', name:'Son -> Father'},
{value:'Father,Daughter',name:'Father -> Daughter'},
{value:'Daughter,Father',name:'Daughter -> Father'},
{value:'Husband,Wife',name:'Husband -> Wife'},
{value:'Wife,Husband',name:'Wife -> Husband'},
{value:'Brother,Sister',name:'Brother -> Sister'},
{value:'Sister,Brother',name:'Sister -> Brother'},
]
export { relations };